import React, { useState, useEffect, useCallback } from "react";
import { getLoggedInUser } from "../helpers";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "./Loader/Loader";
import config from "react-global-configuration";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/scss/_common.scss";
import Wallet from "../pages/Wallet";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const NonCashWallet = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(-1);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeOptions] = useState([10, 20, 30, 40, 50, 100]);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableSorting, setTableSorting] = useState([
    { columnName: "title", direction: "asc" },
  ]);
  const [tableFilter, setTableFilter] = useState([]);
  const [betting_limit, setBettingLimit] = useState("");
  const [res_message, setResMessage] = useState("");
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [userList, setUserList] = useState([]);
  const [walletList, setWalletList] = useState([]);
  const [totalBalance, setTotalBalance] = useState("");
  const [totalNoneCashBalance, setTotalNoneCashBalance] = useState("");
  const [totalCashBalance, setTotalCashBalance] = useState("");
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [depositModalOpen, setDepositModalOpen] = useState(false);

  const loadRecordsTables = useCallback(() => {
    setIsLoading(true);
    betSlipService
      .LimitDetails({ guid: user.guid })
      .then((res) => {
        setUserList(res[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        // swal(res.message, { icon: "error" });
      });
  }, [user.guid]);

  const loadUserWalletTables = useCallback(() => {
    setIsLoading(true);
    const columnSorting = tableSorting[0];
    const reqData = {
      guid: user.guid,
      page_size: pageSize,
      page: currentPage + 1,
      search: tableFilter,
      ...(columnSorting && {
        sort_by: columnSorting.columnName,
        sort_order: columnSorting.direction === "desc" ? "desc" : "asc",
      }),
    };
    betSlipService
      .nonCashWallet(reqData)
      .then((response) => {
        setWalletList(response.noncash_list.data);
        setTotalItemCount(response.noncash_list.total);
        setTotalPageCount(response.noncash_list.last_page);
        setTotalBalance(response.total_balance);
        setTotalNoneCashBalance(response.total_non_cash_balance);
        setTotalCashBalance(response.total_cash_balance);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [user.guid, tableSorting, pageSize, tableFilter, currentPage]);

  useEffect(() => {
    loadRecordsTables();
    loadUserWalletTables();
  }, [loadRecordsTables, loadUserWalletTables]);

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("betting_limit", values.betting_limit);
    formData.append("password", values.password);
    formData.append("guid", user.guid);

    betSlipService
      .updateLimit(formData, config)
      .then((res) => {
        if (res.message) {
          setRight(true);
          setResMessage(res.message);
        } else {
          setWrong(true);
          setResMessage(res.error);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        // swal(response.message, { icon: "error" });
      });
  };

  const handlePerRowsChange = (perPage) => {
    setPageSize(perPage);
    loadUserWalletTables();
  };

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
    loadUserWalletTables();
  };

  const handleSortChange = (tableSorting) => {
    const sortVal = tableSorting.map((value) => ({
      columnName: value.id,
      direction: value.desc ? "desc" : "asc",
    }));
    setTableSorting(sortVal);
    loadUserWalletTables();
  };

  const handleFilterChange = (tableFilter) => {
    setTableFilter(tableFilter);
    loadUserWalletTables();
  };

  const openDepositModal = () => setDepositModalOpen(true);
  const closeDepositModal = () => setDepositModalOpen(false);

  const Redirect = () => {
    const element = document.querySelector(".withdraw_menu a");
    if (element) {
      localStorage.setItem("currentPage", "demo6");
      element.click();
    }
  };

  const onTrigger = (event) => {
    props.parentCallback(true);
  };

  const renderRedirectToRoot = () => {};

  return (
    <React.Fragment>
      {renderRedirectToRoot()}
      {isLoading && <Loader />}
      <div className="account-pages">
        <Modal
          className="withdraw-request-popup"
          isOpen={depositModalOpen}
          // toggle={closeDepositModal}
        >
          {/* <ModalHeader toggle={closeDepositModal}></ModalHeader> */}
          <ModalBody>
            <p onClick={closeDepositModal}>
              <RxCross2 className="close-btn" />
            </p>
            <Wallet setDepositModalOpen={setDepositModalOpen} />
          </ModalBody>
        </Modal>

        <section className="dashboard-section padding-top padding-bottom">
          <Container>
            <Row>
              <Col className="col-lg-12 col-md-12 col-sm-12">
                <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                  <h4 className="title m-0">Menu</h4>
                  <div className="user-toggler" onClick={() => onTrigger()}>
                    <i className="las la-sliders-h"></i>
                  </div>
                </div>
                <Row
                  className="justify-content-center"
                  style={{ marginTop: "auto" }}
                >
                  <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                    <div className="dashboard__card">
                      <div className="dashboard__card-content">
                        <h2 className="price">€{totalBalance || "0.00"}</h2>
                        <p className="info">
                          {t("userProfile.nonCashWallet.totalBalance")}
                        </p>
                        <a className="view-btn">
                          {" "}
                          {t("userProfile.nonCashWallet.viewAll")}
                        </a>
                      </div>
                      {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                    </div>
                  </div>
                  <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                    <div className="dashboard__card">
                      <div className="dashboard__card-content">
                        <h2 className="price">
                          €{totalNoneCashBalance || "0.00"}
                        </h2>
                        <p className="info">
                          {" "}
                          {t("userProfile.nonCashWallet.nonCashBalance")}
                        </p>
                        <a className="view-btn">
                          {t("userProfile.nonCashWallet.viewAll")}
                        </a>
                      </div>
                      {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                    </div>
                  </div>
                  <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                    <div className="dashboard__card">
                      <div className="dashboard__card-content withdraw_menu">
                        <h2 className="price">€{totalCashBalance || "0.00"}</h2>
                        <p className="info ">
                          {t("userProfile.nonCashWallet.withdraw")}
                        </p>
                        <a className="view-btn " onClick={Redirect}>
                          {t("userProfile.nonCashWallet.viewAll")}
                        </a>
                      </div>
                      {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                    </div>
                  </div>
                </Row>
                <div className="table--responsive--md mt-3">
                  <Card style={{ minHeight: "425px" }}>
                    <CardBody className="bg-dark1 user-data">
                      <ReactTable
                        data={walletList}
                        columns={[
                          {
                            Header: t("userProfile.nonCashWallet.bonusCode"),
                            accessor: "bonus_code",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => <span>{row.value || "--"}</span>,
                            width: 290,
                          },
                          {
                            Header: t("userProfile.nonCashWallet.amount"),
                            accessor: "amount",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => (
                              <span>{row.value ? "€" + row.value : "--"}</span>
                            ),
                          },
                          {
                            Header: t(
                              "userProfile.nonCashWallet.rollOverAmount",
                            ),
                            accessor: "rollover_amount",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => (
                              <span>{row.value ? "€" + row.value : "--"}</span>
                            ),
                          },
                          {
                            Header: t("userProfile.nonCashWallet.betAmount"),
                            accessor: "bet_amount",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => (
                              <span>{row.value ? "€" + row.value : "--"}</span>
                            ),
                          },
                          {
                            Header: t("userProfile.nonCashWallet.createdAt"),
                            accessor: "created_date",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => <span>{row.value || "--"}</span>,
                          },
                          {
                            Header: t("userProfile.nonCashWallet.approvedAt"),
                            accessor: "approved_date",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => <span>{row.value || "--"}</span>,
                          },
                          {
                            Header: t("userProfile.nonCashWallet.status"),
                            accessor: "status",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => {
                              const statusMap = {
                                0: "Rejected",
                                1: "Approved",
                                2: "Pending",
                                3: "Customized",
                                4: "Cancelled by Admin",
                              };
                              return (
                                <span>{statusMap[row.value] || "--"}</span>
                              );
                            },
                          },
                        ]}
                        loading={isLoading}
                        defaultPageSize={pageSize}
                        pageSizeOptions={pageSizeOptions}
                        sortable={true}
                        multiSort={false}
                        resizable={true}
                        filterable={true}
                        onSortedChange={handleSortChange}
                        onPageSizeChange={handlePerRowsChange}
                        onPageChange={handlePageChange}
                        onFilteredChange={handleFilterChange}
                        manual={true}
                        minRows="0"
                        pages={totalPageCount}
                        showPagination={walletList.length > 0}
                        NoDataComponent={() => (
                          <div style={{ textAlign: "center", padding: "1rem" }}>
                            {t("userProfile.nonCashWallet.noRewards")}
                          </div>
                        )}
                      />
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return { user };
};

export default connect(mapStateToProps)(NonCashWallet);
